import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  LoaderModule,
  NfFormsModule,
  TableModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { ApprovalsPanelComponent } from './approvals-panel.component'
import { ApprovalsHelpComponent } from './components/approvals-help/approvals-help.component'
import { ApprovalsValidationComponent } from './components/approvals-validation/approvals-validation.component'
import { RequestDetailGridRestrictedBreaksComponent } from './components/request-detail-grid/request-detail-grid-restricted-breaks.component'
import { RequestsGridComponent } from './components/requests-grid/requests-grid.component'
import { RequestDetailGridForceReconComponent } from './components/request-detail-grid/request-detail-grid-force-recon.component'

@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    TableModule,
    GenericComponentsModule,
    FormsModule,
    ToggleModule,
    ReactiveFormsModule,
    ButtonModule,
    ResizeHandleModule,
    LoaderModule,
    NfFormsModule,
    NgbNavModule,
  ],
  declarations: [
    ApprovalsPanelComponent,
    RequestDetailGridForceReconComponent,
    RequestDetailGridRestrictedBreaksComponent,
    RequestsGridComponent,
    ApprovalsHelpComponent,
    ApprovalsValidationComponent,
  ],
  exports: [ApprovalsPanelComponent],
})
export class ApprovalsModule {}

export { ApprovalsPanelComponent }
